import { Button } from "@atoms";
import { AuthSection } from "@organisms";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export const PendingPageTemplate = (): JSX.Element => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex">
      <AuthSection />

      {/* Right side - Content */}
      <div className="w-full lg:w-1/2 min-h-screen flex items-center justify-center bg-white">
        <div className="w-full max-w-md px-8 text-center">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              {t("auth.pending.title")}
            </h1>
            <p className="text-gray-600 text-lg">
              {t("auth.pending.description")}
            </p>
          </div>

          <div className="w-full max-w-xs mx-auto">
            <Button
              variant="primary"
              label={t("auth.pending.backToHome")}
              stretch
              color="brand-orange"
              hoverColor="primary-dark"
              textColor="white"
              onClick={() => navigate("/signin")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
